module.exports = __webpack_public_path__ + "static/media/huzige.6809e44c.png";